































































































































































































import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  CHANGE_SUBSTITUTION_STATUS,
  FETCH_SUBSTITUTION_LIST,
  LOAD_ABSENCE_REASON_LIST,
  SUBSTITUTION_START_PROCESSING
} from '@/store/action-types'
import { Substitution } from '@/model/disposition/Substitution'
import { AbsenceReason } from '@/model/absences/AbsenceReason'
import { hexToRgba } from '@/services/hex-to-rgba'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { ChangeSubstitutionPayload, SelectedSubstitutionPayload } from '@/types/payload'
import { SnackbarStateEnum } from '@/types/enums'
import { TranslateResult } from 'vue-i18n'

interface SelectedSubstitution {
  rowId: number
  nextAction: string
  dateTo: string
  addressNumber: string
  STVSpecification: string
}

interface NextAction {
  id: number
  name: string
}

interface AddressItem {
  id: string
  label: string
}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  tableHeight: string
  showActive: boolean
  loading: boolean
  substitutionList: Substitution[]
  addressList: AddressItem[]

  nextActionList: NextAction[]
  filteredNextActionList: NextAction[]
  selectedNextAction: NextAction | undefined
  isDateInputActivate: boolean
  dateFromFormatted: string | null
  dateFrom: string | null
  menuFrom: boolean
  dateToFormatted: string | null
  dateTo: string | null
  menuTo: boolean
  dateRules: Function[]
  selectedDateFrom: string
  selectedDateTo: string
  absenceReasonList: AbsenceReason[]
  selectedAbsenceReason: any[]
  selectedAddress: string
  selectedCleaningEmployee: number | null


  headers: any[]
  gridData: Substitution[]
  filteredGridData: Substitution[]
  overlayNoRowsTemplate: string
  selectedItems: SelectedSubstitution[]
  currentSelectedRowList: Substitution[]
  isCheckClicked: boolean
}

export default Vue.extend({
  name: 'Substitution',

  components: {
    ProgressCircular
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      tableHeight: '',
      showActive: true,
      loading: false,
      substitutionList: [],
      addressList: [],

      nextActionList: [
        {id: 1, name: 'Info versenden'},
        {id: 2, name: 'Änderungsinfo senden'},
        {id: 3, name: 'Antwort senden'},
        {id: 4, name: 'Info Ende'},
        {id: 5, name: 'keine Rückmeldung'}
      ],
      filteredNextActionList: [],
      selectedNextAction: undefined,
      isDateInputActivate: false,
      dateFromFormatted: '',
      dateFrom: '',
      menuFrom: false,
      dateToFormatted: '',
      dateTo: '',
      menuTo: false,
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        },

        (value: string) => {
          return !!value
        }
      ],
      selectedDateFrom: '',
      selectedDateTo: '',
      absenceReasonList: [],
      selectedAbsenceReason: [],
      selectedAddress: '',
      selectedCleaningEmployee: null,


      headers: [
        { text: this.$t('disposition.clerkIn').toString(), value: 'addressEmployee', align: 'start', groupable: false },
        { text: this.$t('disposition.referenceDate').toString(), value: 'date', align: 'start', groupable: false, width: 120 },
        { text: this.$t('disposition.projectNumber').toString(), value: 'projectNumber', align: 'start', groupable: false, width: 120 },
        { text: this.$t('disposition.STVSpecification').toString(), value: 'STVSpecification', align: 'start', groupable: false, width: 180 },
        { text: this.$t('disposition.representation').toString(), value: 'representation', align: 'start', groupable: false, width: 200 },
        { text: this.$t('disposition.nextAction').toString(), value: 'nextAction', align: 'start', groupable: false, width: 200 },
        { text: this.$t('disposition.selection').toString(), value: 'selection', align: 'center', groupable: false, sortable: false },
      ],
      gridData: [],
      filteredGridData: [],
      overlayNoRowsTemplate: this.$t('errors.noRowsToShow').toString(),
      selectedItems: [],
      currentSelectedRowList: [],
      isCheckClicked: false
    }
  },

  watch: {
    dateFromFormatted (newVal: string | null): void {
      if(newVal) {
        this.dateFrom = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
        if(moment(newVal, 'DD.MM.YYYY').isValid()) {
          this.onFromValueChange(newVal)
        }
      } else {
        this.dateFrom = ''
      }
    },

    dateToFormatted (newVal: string | null): void {
      if(newVal) {
        this.dateTo = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
        if(moment(newVal, 'DD.MM.YYYY').isValid()) {
          this.onToValueChange(newVal)
        }
      } else {
        this.dateTo = ''
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    setShowButtonIcon (): string {
      if(this.showActive) {
        return 'visibility_off'
      } else {
        return 'visibility'
      }
    },

    isChangeStatusDisabled (): boolean {
      return this.currentSelectedRowList.length === 0
    }
  },

  methods: {
    customFilter (item: Substitution, queryText: string): boolean {
      const textOne = item.fullName.toLowerCase()
      const textTwo = item.shortName.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textOne.indexOf(searchText) > -1 ||
          textTwo.indexOf(searchText) > -1
    },

    checkDisabled (item: Substitution): boolean {
      if(item.deleted === 1 || item.nextAction === 'Info Ende' || item.nextAction === 'keine Rückmeldung' || (item.nextAction === 'Antwort senden' && !item.STVEmployeeId)) {
        return true
      } else {
        return false
      }
    },

    onShowSubstitution (): void {
      this.showActive = !this.showActive
      if(this.showActive) {
        this.filteredNextActionList = this.nextActionList.filter((item: NextAction) => item.id === 1 || item.id === 2 || item.id === 3)
        if(this.selectedNextAction && this.selectedNextAction.id !== 1 || 2 || 3)
        this.selectedNextAction = this.nextActionList[0]
      } else {
        this.filteredNextActionList = this.nextActionList
      }

      this.selectedAddress = ''
      this.isDateInputActivate = false
      this.selectedDateFrom = ''
      this.selectedDateTo = ''
      this.dateFromFormatted = ''
      this.dateToFormatted = ''
      this.selectedAbsenceReason = []
      this.selectedCleaningEmployee = null
      this.selectedItems = []
      this.deselectAll()
      const form1: any = this.$refs['form1']
      form1.resetValidation()
      const form2: any = this.$refs['form2']
      form2.resetValidation()

      this.fetchData()
    },

    onDateFromChange (date: string): void {
      this.dateFromFormatted = moment(date).format('DD.MM.YYYY')
      this.onFromValueChange(this.dateFromFormatted)
    },

    onFromValueChange (value: string): void {
      this.selectedDateFrom = value
    },

    onFromBlur (): void {
      this.dateFromFormatted = this.dateFrom && moment(this.dateFrom).isValid() ? moment(this.dateFrom).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menuFrom) {
          this.menuFrom = false
        }
      }, 100)
    },

    onDateToChange (date: string): void {
      this.dateToFormatted = moment(date).format('DD.MM.YYYY')
      this.onToValueChange(this.dateToFormatted)
    },

    onToValueChange (value: string): void {
      this.selectedDateTo = value
    },

    onToBlur (): void {
      this.dateToFormatted = this.dateTo && moment(this.dateTo).isValid() ? moment(this.dateTo).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menuTo) {
          this.menuTo = false
        }
      }, 100)
    },

    onFilterClick () {
      this.selectedItems = []
      this.currentSelectedRowList = []
      this.deselectAll()
      this.gridData.forEach((item: Substitution) => {
        item.isChecked = false
      })

      this.filteredGridData = _.cloneDeep(this.gridData)

      if(this.selectedNextAction) {
        this.filteredGridData = this.filteredGridData.filter((item: Substitution) => item.nextAction === this.selectedNextAction!.name)
      }

      if(this.selectedAddress) {
        this.filteredGridData = this.filteredGridData.filter((item: Substitution) => item.addressNumber === this.selectedAddress)
      }

      if(this.isDateInputActivate) {
        if(this.selectedDateFrom && this.selectedDateTo) {
          this.filteredGridData = this.filteredGridData.filter((item: Substitution) => moment(item.date).isSameOrAfter(moment(this.selectedDateFrom, 'DD.MM.YYYY').startOf('day')) && moment(item.date).isSameOrBefore(moment(this.selectedDateTo, 'DD.MM.YYYY').endOf('day')))
        }
      }

      if(this.selectedAbsenceReason && this.selectedAbsenceReason.length > 0) {
        this.filteredGridData = this.filteredGridData.filter((item: Substitution) => this.selectedAbsenceReason.includes(item.absenceReason))
      }

      if(this.selectedCleaningEmployee) {
        this.filteredGridData = this.filteredGridData.filter((item: Substitution) => item.employeeId === this.selectedCleaningEmployee)
      }

    },

    getFormattedDate (date: any): string {
      return moment(date, 'DD.MM.YYYY HH:mm').format('DD.MM.YYYY')
    },

    getFormattedDate2 (date: any): string {
      return moment(date).format('DD.MM.YYYY')
    },


    getRepresentationLabel (item: any): string {
      if(item.STVEmployeeId) {
        return `${item.STVShortName} ${item.STVFullName} (${item.STVPersonalNumber})`
      } else {
        return '-- fehlt noch --'
      }
    },

    onItemSelectionChange (item: Substitution): void {
      this.isCheckClicked = true
      if(item.isChecked && item.nextAction !== "Antwort senden") {
        const foundSelected: SelectedSubstitution | undefined = this.selectedItems.find((selected: SelectedSubstitution) => selected.dateTo === item.dateTo && selected.addressNumber === item.addressNumber)
        if(!foundSelected) {
          this.filteredGridData.forEach((substitution: Substitution) => {
            if (substitution.employeeId === item.employeeId && substitution.dateTo === item.dateTo && substitution.addressNumber === item.addressNumber) {
              substitution.isChecked = true
              this.selectedItems.push(
                  {
                    rowId: substitution.rowId,
                    nextAction: substitution.nextAction,
                    dateTo: substitution.dateTo,
                    addressNumber: substitution.addressNumber,
                    STVSpecification: substitution.STVSpecification
                  }
              )
            }
          })
        } else {
          this.selectedItems.push(
              {
                rowId: item.rowId,
                nextAction: item.nextAction,
                dateTo: item.dateTo,
                addressNumber: item.addressNumber,
                STVSpecification: item.STVSpecification
              }
          )
        }
      } else if(item.isChecked && item.nextAction === "Antwort senden") {
        const foundSelected: SelectedSubstitution | undefined = this.selectedItems.find((selected: SelectedSubstitution) => selected.dateTo === item.dateTo && selected.addressNumber === item.addressNumber)
        if(!foundSelected) {
          this.filteredGridData.forEach((substitution: Substitution) => {
            if (substitution.employeeId === item.employeeId && substitution.dateTo === item.dateTo && substitution.addressNumber === item.addressNumber && substitution.STVEmployeeId) {
              substitution.isChecked = true
              this.selectedItems.push(
                  {
                    rowId: substitution.rowId,
                    nextAction: substitution.nextAction,
                    dateTo: substitution.dateTo,
                    addressNumber: substitution.addressNumber,
                    STVSpecification: substitution.STVSpecification
                  }
              )
            }
          })
        } else {
          this.selectedItems.push(
              {
                rowId: item.rowId,
                nextAction: item.nextAction,
                dateTo: item.dateTo,
                addressNumber: item.addressNumber,
                STVSpecification: item.STVSpecification
              }
          )
        }
      } else {

          const index: number = _.findIndex(this.selectedItems, { rowId: item.rowId })
          this.selectedItems.splice(index, 1)
      }
    },

    async onStartProcessingClick (): Promise<void> {
      this.loading = true
      const payload: SelectedSubstitutionPayload[] = this.selectedItems.map((item: SelectedSubstitution) => {
        return {RowID: item.rowId, NSchritt: item.nextAction, STVVorgabe: item.STVSpecification}
      })

      try {
        const response: boolean = await this.$store.dispatch(SUBSTITUTION_START_PROCESSING, payload)
        if (response) {
          this.selectedItems = []
          this.fetchData()
        }
      } catch {
      } finally {
        this.loading = false
      }
    },

    rowClick (item: Substitution, row: any): void {
      if(!this.isCheckClicked) {
        if (row.isSelected) {
          const index: number = this.currentSelectedRowList.indexOf(item)
          this.currentSelectedRowList.splice(index, 1)
          row.select(false)
        } else {
          this.currentSelectedRowList.push(item)
          row.select(true)
        }
      } else {
        if(!row.isSelected) {
          row.select(false)
        }
      }

      this.isCheckClicked = false
    },

    deselectAll (): void {
      const table: any = this.$refs['table']
      if(table) {
        table.toggleSelectAll()
      }
    },

    onChangeStatus (action: number): void {
      let payload: ChangeSubstitutionPayload = {
        action: undefined,
        data: []
      }

      switch (action) {
        case 1:
          payload.action = 'GoToStart'
          break
        case 2:
          payload.action = 'GoToPreviousStep'
          break
        case 3:
          payload.action = 'GoToNextStep'
          break
        case 4:
          payload.action = 'GoToEnd'
          break
        case 5:
          payload.action = 'Enable'
          break
        case 6:
          payload.action = 'Disable'
          break
      }

      if(this.currentSelectedRowList.length > 0) {
        payload.data = this.currentSelectedRowList.map((item: Substitution) => {
          return { RowID: item.rowId, NSchritt: item.nextAction, STVVorgabe: item.STVSpecification }
        })

        if (payload.action) {
          this.changeStatus(payload)
        }
      }
    },

    async changeStatus(payload: ChangeSubstitutionPayload): Promise<void> {
      try {
        this.loading = true
        const response = await this.$store.dispatch(CHANGE_SUBSTITUTION_STATUS, payload)
        if(response) {
          this.deselectAll()
          this.currentSelectedRowList = []
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.selectedItems = []
          this.fetchData()
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.loading = false
      }
    },

    async fetchData (): Promise<void> {
      this.loading = true
      const payload: number = this.showActive ? 1 : 0
      try {
        const response: Substitution[] = await this.$store.dispatch(FETCH_SUBSTITUTION_LIST, payload)
        if (response) {
          this.gridData = response
          this.filteredGridData = this.gridData.filter((item: Substitution) => item.nextAction === this.selectedNextAction!.name)
          this.substitutionList = _.uniqBy(this.gridData, 'employeeId')
          this.addressList = _.uniqBy(this.gridData, 'addressName').map((item: Substitution) => {
            return {id: item.addressNumber, label: item.addressLabel}
          })
        }
      } catch {
      } finally {
        this.loading = false
      }
    },

    async fetchAbsenceReason (): Promise<void> {
      const data: AbsenceReason[] = await this.$store.dispatch(LOAD_ABSENCE_REASON_LIST)
      this.absenceReasonList = _.sortBy(data, [function(o) { return o.description.toLocaleLowerCase(); }])
    },

    onResize (): void {
      if(this.$refs.toolbar && this.$refs.filter && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.toolbar as HTMLElement).clientHeight + (this.$refs.filter as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 150px - ${height}px)`
        } else {
          this.tableHeight = '500px'
        }
      } else {
        this.tableHeight = '500px'
      }
    }

  },

  mounted () {
    this.filteredNextActionList = this.nextActionList.filter((item: NextAction) => item.id === 1 || item.id === 2 || item.id === 3)
    this.selectedNextAction = this.nextActionList[0]
    this.fetchData()
    this.fetchAbsenceReason()
  }
})
